<template>
      <b-card no-body>
        <b-card-header>
            <b-row>
                 <b-col md="9">
                    <h3>Formulário - Avaliação e Monitoramento do Programa Mães Unidas</h3>
                    <br>
                    <p><b>Nome do beneficiário:</b> {{atendimento.beneficiaria.nome}}</p>
                    <p><b>Data de atendimento:</b> {{formatDate(atendimento.data_encontro)}}</p>
                 </b-col>
                 <b-col md="3">
                    <p><b>Nome:</b> {{usuario.nome}}</p>
                    <p><b>Perfil:</b> {{usuarioLogado.perfil}}</p>
                    <p><b>Estado:</b> {{usuarioLogado.estado}}</p>
                    <p><b>Município:</b> {{usuarioLogado.municipio}}</p>
                 </b-col>
            </b-row>
        </b-card-header>
          <b-card-body>
            <span v-for="(pergunta, index) in perguntas" :key="index">
              <b-row>
                <b-col md="8">
                  <p><b>{{index + 1}}) {{pergunta.pergunta}}</b> <br>
                  <span v-if="pergunta.valida !== true" style="width: 100%; margin-top: .25rem; font-size: 80%; color: #dc3545;"><b>Preencha para salvar.</b></span>  
                  </p>             
                </b-col>
                <b-col md="4">
                  <b-form-group>
                    <b-form-radio-group v-model="pergunta.opcao" :options="options"  :name="pergunta.id"></b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col md="5" v-show="pergunta.opcao === 'I'">
                  <b-form-group>
                   <b-form-input type="text" v-model="pergunta.justificativa" id="name" :placeholder="'Justificativa para o indefinido da pergunta ' + (index + 1)"></b-form-input>                    
                  <span v-if="validaPerguntasJustificativas[index]" style="width: 100%; margin-top: .25rem; font-size: 80%; color: #dc3545;"><b>Preencha para salvar.</b></span>  
                  </b-form-group>                  
                </b-col>
              </b-row>
              <span v-show="pergunta.opcao === 'S'">
              <b-row v-for="(pergunta, index2) in pergunta.secundaria" :key="index2">
                <b-col md="8">
                  <p>&nbsp;&nbsp;&nbsp;<b><i>{{index + 1}}.{{index2 + 1}}) {{pergunta.pergunta}}</i></b> <br>
                   <span v-if="pergunta.valida !== true" style="width: 100%; margin-top: .25rem; font-size: 80%; color: #dc3545;"><b>&nbsp;&nbsp;&nbsp;Preencha para salvar.</b></span>  
                  </p>
                </b-col>
                <b-col md="4">
                  <b-form-group>
                    <b-form-radio-group v-model="pergunta.opcao" :options="options" :name="'secundaria' + pergunta.id"></b-form-radio-group>
                  </b-form-group>
                </b-col>
                 <b-col md="5" v-show="pergunta.opcao === 'I'">
                  <b-form-group>
                   <b-form-input type="text" v-model="pergunta.justificativa" id="name" :placeholder="'Justificativa para o indefinido da pergunta ' + (index + 1)+'.'+(index2 + 1)"></b-form-input>
                   <span v-if="validasubPerguntasJustificativas[index2]" style="width: 100%; margin-top: .25rem; font-size: 80%; color: #dc3545;"><b>&nbsp;&nbsp;&nbsp;Preencha para salvar.</b></span>  
                  </b-form-group>
                </b-col>
              </b-row>
              </span>
            </span>
        </b-card-body>
        <b-card-footer class="p-12">
        <b-button variant="primary" @click="onSubmit"><i class="fa fa-save"></i> Salvar e Finalizar</b-button>
        </b-card-footer>
      </b-card>
</template>

<script>
import Vue from 'vue'
import StarRating from 'vue-star-rating'
import SessionStorage from '@/services/session-storage'
import Pagination from '@/components/shared/Pagination'
import miniToastr from 'mini-toastr'

miniToastr.init()

export default {
  components: {
    StarRating,
    Pagination
  },
  created () {
    this.$store.dispatch('buscaAtendimento', this.$route.params.id)
    this.$store.dispatch('getUsuario', SessionStorage.get('usuario'))
    this.$store.dispatch('buscarPerguntas')
  },
  data () {
    return {
      selected: [],
      options: [
        { text: 'Sim', value: 'S' },
        { text: 'Não', value: 'N' },
        { text: 'Indefinido', value: 'I' }
      ],     
      validaPerguntasJustificativas: {0:false, 1:false, 2:false,3:false, 4:false, 5:false},     
      validasubPerguntasJustificativas: {0:false, 1:false, 2:false,3:false, 4:false, 5:false},
      dadosPessoais: {
        rg: null,
        dataNascimento: null,
        sexo: null,
        nis: null,
        gestante_mae: null,
        estado_civil: null,
        escolaridade: null,
        telefone: null,
        sigla: null,
        cidade: null,
        bairro: null,
        endereco: null,
        complemento: null,
        numero: null,
        cep: null,
        profissao: null
      },
      usuarioLogado: {
        municipio: '',
        estado: '',
        perfil: ''
      },
      usuarioCorrente: parseInt(SessionStorage.get('usuario'))
    }
  },
  computed: {
    usuario () {
      return this.$store.state.usuario.usuarioEditar
    },
    perguntas () {      
      return this.$store.state.pergunta.perguntas
    },
    atendimento () {
      return this.$store.state.atendimento.atendimento
    }
  },
  watch: {
    'usuario.dados_pessoais.cidade': function () {
      this.usuarioLogado.municipio = this.usuario.dados_pessoais.cidade.cidade
    },
    'usuario.dados_pessoais.cidade.estado': function () {
      this.usuarioLogado.estado = this.usuario.dados_pessoais.cidade.estado.estado
    },
    'usuario.perfil': function () {
      this.usuarioLogado.perfil = this.usuario.perfil.nome
    }
  },
  methods: {
    formatDate (criadoEm) {
      let date = new Date(criadoEm)

      let day = date.getDate()
      let month = (date.getMonth() + 1)

      if (month < 10) {
        month = '0' + month
      }

      if (day < 9) {
        day = '0' + (day + 1)
      } else {
        day = day + 1
      }

      return day + '/' + month + '/' + date.getFullYear()
    },
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    onSubmit: function () {
      if (this.validarQuestionario()) {
        this.salvar()
      }
    },
    validarQuestionario: function () {
      
       let validaPergunta = false
       let validaSubPergunta = false
       let validaPerguntaJustificativa = false
       let validaPerguntaJustificativaSecundaria = false

       for (let i = 0; i < this.perguntas.length; i++) {
         if (this.perguntas[i].opcao === undefined) {
           this.perguntas[i].valida = false                        
           validaPergunta = true      
         }else{
            this.perguntas[i].valida = true           
         }
       }
      
      for (let i = 0; i < this.perguntas.length; i++) {
        if (this.perguntas[i].opcao === 'S') {
          if (this.perguntas[i].secundaria) {
            for (let j = 0; j < this.perguntas[i].secundaria.length; j++) {              
              if (this.perguntas[i].secundaria[j].opcao === undefined) {                 
               this.perguntas[i].secundaria[j].valida = false
               validaSubPergunta = true       
              }else{                
                this.perguntas[i].secundaria[j].valida = true
              }
            }
          }
        }
      }

      for (let i = 0; i < this.perguntas.length; i++) {
        if (this.perguntas[i].opcao === 'I') {
          if (this.perguntas[i].justificativa === undefined) {            
            this.$set(this.validaPerguntasJustificativas, i, true)   
            validaPerguntaJustificativa = true
          }else{
            this.$set(this.validaPerguntasJustificativas, i, false)   
          }
        }
      }

      for (let i = 0; i < this.perguntas.length; i++) {
        if (this.perguntas[i].opcao === 'S') {
          if (this.perguntas[i].secundaria) {
            for (let j = 0; j < this.perguntas[i].secundaria.length; j++) {
              if (this.perguntas[i].secundaria[j].opcao === 'I') {
                if (this.perguntas[i].secundaria[j].justificativa === undefined) {
                  this.$set(this.validaPerguntasJustificativas, j, true) 
                      this.$set(this.validasubPerguntasJustificativas, j, true)   
                      validaPerguntaJustificativaSecundaria = true
                    }else{
                      this.$set(this.validasubPerguntasJustificativas, j, false)   
                }                                 
              }
            }
          }
        }
      }

      if(validaPergunta == true){
         miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
         miniToastr.error('Preencha todas as respostas antes de finalizar!', 'Alerta!', 7000)
         return false
      }

      if(validaSubPergunta == true){
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
        miniToastr.error('Preencha todas as respostas secundárias antes de finalizar!', 'Alerta!', 7000)
        return false
      }

      if(validaPerguntaJustificativa == true){
        miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
        miniToastr.error('Verifica se tem justificativa em texto para pergunta primaria!', 'Alerta!', 7000)
        return false
      }

      if(validaPerguntaJustificativaSecundaria == true){
         miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
         miniToastr.error('Verifica se tem justificativa em texto para pergunta secundária!', 'Alerta!', 7000)
         return false
      }

      return true
    },
    salvar (id) {
      let data = {
        atendimento_id: this.$route.params.id,
        respostas: this.perguntas
      }
      this.$bvModal.msgBoxConfirm('Confirma a realização da avaliação?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.post('api/atendimento-responder', data).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$router.push('/beneficiaria/' + this.atendimento.beneficiaria.id + '/visualizar')
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
        }
      })
    }
  }
}
</script>

<style scoped>
    .action{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/voluntario/FormularioAtendimento.vue